import request from '@/utils/request'

export function getmroombp(roomno) {
  return request({
    url: `/api/mroombp/` + roomno,
    method: 'get',
  })
}

// export function getmroombp(roomno) {
//   return request({
//     url: '/api/mroombp',
//     method: 'get',
//     params: { roomno: roomno },
//   })
// }
